/*
對外部函式揭露多組action creator函式
同步action: 對象 {type: 'xxx', data: 數據值}
非同步action: 函數 dispatch => {}
*/
import { SET_HEAD_TITLE, RECERVE_USER, SHOW_ERROR_MSG, RESET_USER } from './action-types'
import { reqLogin, reqSSO, reqMemberRoleMenu } from '../api'
import storageUtils from '../utils/storageUtils'
import memoryUtils from '../utils/memoryUtils'

/********************************************************/
/*
sync action(同步)
*/
// 設置[頭部標題]
export const act_setHeadTitle = (headTitle) => ({ type: SET_HEAD_TITLE, data: headTitle })
// 接收[用戶]登入資訊
export const act_receiveUser = (user) => ({ type: RECERVE_USER, user })
// 註銷[用戶]登入資訊
export const act_logout = () => {
    storageUtils.removeUser()
    memoryUtils.user = {}
    return { type: RESET_USER }
}
// 接收[錯誤]
export const act_showErrorMsg = (error) => ({ type: SHOW_ERROR_MSG, data: error })

/********************************************************/
/*
async action(非同步)
*/
/* 登入方法*/
export const act_login = (username, password) => {
    storageUtils.removeUser()
    memoryUtils.user = {}

    return async dispatch => {
        const result = await reqLogin(btoa(username), btoa(password))
        if (result.status === "YES") {
            const user = result
            user.menus = []
            // console.log('user',user)
            const role = await reqMemberRoleMenu(user.role, user.token)
            //  console.log('role',role)
            if (role) {
                user.menus = (role.menus) ? role.menus.reduce((pre, item) => {
                    if (item) {
                        pre.push(item.linkUrl)
                    }
                    return pre
                }, []) : []
            } else {
                user.menus = []
            }
            memoryUtils.user = user    // 保存到記憶體，畫面刷新(或離開頁面)就會消失
            storageUtils.setUser(user) // user保存storage
            // 2.1 分發同步ACTION
            dispatch(act_receiveUser(user))

        } else {
            // 2.2 分發同步ACTION
            const error = result.message ? result.message : ""
            dispatch(act_showErrorMsg(error))
        }
    }
}

export const act_sso = (username, system) => {
    storageUtils.removeUser()
    memoryUtils.user = {}
    
    return async dispatch => {
        const result = await reqSSO(username, system)
        if (result.status === "YES") {
            const user = result
            user.menus = []

            const role = await reqMemberRoleMenu(user.role, user.token)
            if (role) {
                user.menus = (role.menus) ? role.menus.reduce((pre, item) => {
                    if (item) {
                        pre.push(item.linkUrl)
                    }
                    return pre
                }, []) : []
                memoryUtils.user = user    // 保存到記憶體，畫面刷新(或離開頁面)就會消失
                storageUtils.setUser(user) // user保存storage
               // console.log('user', user)
                // 2.1 分發同步ACTION
                dispatch(act_receiveUser(user))
            } else {
                user.menus = []
                memoryUtils.user = user    // 保存到記憶體，畫面刷新(或離開頁面)就會消失
                storageUtils.setUser(user) // user保存storage
                // 2.1 分發同步ACTION
                dispatch(act_receiveUser(user))
            }
        } else {
            // 2.2 分發同步ACTION
            const error = result.message
            dispatch(act_showErrorMsg(error))
        }
    }
}